import { Action } from '@ngrx/store';

export enum ActionTypes {
  GET_ROOT_FOLDER_REQUEST = '[GET_ROOT_FOLDER] Request',
  GET_ROOT_FOLDER_SUCCESS = '[GET_ROOT_FOLDER] Success',
  GET_ROOT_FOLDER_FAILURE= '[GET_ROOT_FOLDER] Failure',
}

export class GetRootFolderRequest implements Action {
  readonly type = ActionTypes.GET_ROOT_FOLDER_REQUEST;
  constructor(public payload: any) {}
}

export class GetRootFolderSuccessAction implements Action {
  readonly type = ActionTypes.GET_ROOT_FOLDER_SUCCESS;
  constructor(public payload: any) {}
}

export class GetRootFolderFailureAction implements Action {
  readonly type = ActionTypes.GET_ROOT_FOLDER_FAILURE;
  constructor(public payload: any) {}
}

export type Actions = GetRootFolderRequest | GetRootFolderSuccessAction | GetRootFolderFailureAction;
